import {isEqual} from "lodash"

export function objectsAreEqual(base: any, compare: any) {
  if (undefined === base && undefined===compare)
    return true
  if (undefined === base && compare)
    return  false
  if (base && undefined === compare)
    return false

  const b = objectCleanValues(base)
  const c = objectCleanValues(compare)

  return isEqual(b, c)
}

export function objectCleanValues(obj: any) {
  if (!(!!obj))
    return

  const o: any = {}
  Object.keys(obj).map(k => {
    if (!!obj[k])
      o[k] = obj[k]
  })

  if (Object.keys(o).length < 1)
    return
  else
  return o
}
